import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { resetCurrentPurchaseQuote } from '../../actions/purchaseQuotes_actions';
import { addNewFavorite } from '../../actions/favorites_actions';
import { addNewCustomerFavorite, inListError, clearInListError } from '../../actions/favoriteList_actions';

import NewFavoriteModal from '../../components/Favorites/favoriteModal';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  }
  return errors
}


let newFavoriteModal = reduxForm({
    form: 'newFavoriteModal',
})(NewFavoriteModal);

const selector = formValueSelector('newFavoriteModal')

function mapStateToProps(state) {
    const inventoryItemValue = selector(state, 'InventoryItem_id');
    return {
        inventoryItemValue: inventoryItemValue,

        currenInventoryItem: state.inventories.currentInventory,
        inventoryItems: state.inventories.all,
        isLoading: state.inventories.isLoading,
        error: state.inventories.error,

        inList: state.customerFavorites.inList
    }
}

export default connect(mapStateToProps, { addNewCustomerFavorite, addNewFavorite, fetchInventories, selectInventory, resetCurrentInventory,
                                          inListError, clearInListError })(newFavoriteModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Favorites/favoriteModal.jsx